import { z } from 'zod'

const DateFilters = [
  'thisCalendarWeek',
  'lastCalendarWeek',
  'thisMonth',
  'nextMonth',
  'next7Days',
  'next30Days',
  'next90Days',
  'custom',
] as const

export const DateFilterEnum = z.enum(DateFilters)
export type DateFilterType = z.infer<typeof DateFilterEnum>

// Kept in groups to display Separator between groups
export const dateOptionGroups: DateFilterType[][] = [
  ['thisCalendarWeek', 'lastCalendarWeek', 'thisMonth', 'nextMonth'],
  ['next7Days', 'next30Days', 'next90Days'],
  ['custom'],
]
